import { Typography } from 'antd';
import { isNil, noop } from 'lodash';
import React, { useEffect, useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import AssetUsersSearchModal from './AssetUsersSearchModal';

export type AssetUsersSelectedType = {
  assetid?: number;
  relvalue?: string;
  assetrelid?:number;
};

export type AssetUsersSelectProps = {
  onChange?: any;
  value?: AssetUsersSelectedType;
  onlyAssetId?: boolean;
  clear?: boolean;
  isCreate?: boolean;
  display?: boolean;
  onCancel?: () => void;
  valueToDisplay?: AssetUsersSelectedType;
  ctref?: string;
  phase?:any
  selectedRowKeys?: boolean;
  assetid:number
};

const AssetUsersSelect = ({
  ctref,
  onChange = noop,
  value,
  onlyAssetId,
  clear,
  isCreate,
  onCancel,
  display,
  valueToDisplay,
  selectedRowKeys,
  phase,
  assetid
}: AssetUsersSelectProps) => {
  const [Params, setParams] = useState<AssetUsersSelectedType>({
    assetid: value?.assetid,
    assetrelid: value?.assetrelid,
    relvalue: value?.relvalue,
  });

  const { visible, close, open } = useModalState(false);

  const [onClear, setOnClear] = useState(false);

  const handleSelect = (item: any) => {
    onlyAssetId ? onChange(item.assetid) : onChange(item);

    setParams({
      assetid: assetid,
      assetrelid: item?.assetrelid,
      relvalue: item?.relvalue,
    });
    // close();
    setOnClear(true);
  };


  useEffect(() => {
    setOnClear(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    value = undefined;
    setParams({
      assetrelid: undefined,
      relvalue: undefined,
      assetid: undefined,
    });
  }, [clear]);
  const [visibleModal, setvisibleModal] = useState(false);

  return (
    <>
      {display ? (
        <Typography.Link
          onClick={() => {
            setvisibleModal(true);
          }}
          title="Open details"
          ellipsis
        >
          {valueToDisplay?.assetrelid
            ? `${valueToDisplay.assetrelid ?? ''} - ${
                valueToDisplay.relvalue ?? ''
              } `
            : onlyAssetId && !value?.assetrelid
            ? Params?.assetrelid
              ? `${Params.relvalue ?? ''} `
              : isCreate
              ? 'Create an Asset....'
              : 'Select an Asset'
            : value?.assetrelid
            ? `${value.relvalue ?? ''} `
            : isCreate
            ? 'Create an Asset....'
            : Params?.assetrelid
            ? `${Params.relvalue ?? ''} `
            : 'Select an Asset'}
        </Typography.Link>
      ) : (
        <AppSearchInput
          onSearch={() => {
            open();
            localStorage.removeItem('searchParams');
            localStorage.removeItem('searchParams_components');
          }}
          value={
            <Typography.Link
              onClick={() => {
                setvisibleModal(true);
              }}
            >
              {onClear && !value?.assetid
                ? assetid && value !== undefined && !isNil(value)
                  ? `${Params.assetrelid ?? ''}  -  ${
                      Params.relvalue ?? ''
                    }`
                  : 'Select an Asset'
                : assetid && value !== undefined && !isNil(value)
                ? `${value.assetrelid ?? ''}  -  ${value.relvalue ?? ''}`
                : 'Select an Asset'}
            </Typography.Link>
          }
        />
      )}
      <AssetUsersSearchModal
        visible={visible}
        onCancel={close}
        onSelect={handleSelect}
        ctref={ctref}
        phase={phase}
        assetid={assetid}
        selectedRowKeys={selectedRowKeys}
        id={Params.assetid??0}
      />
     
    </>
  );
};

export default AssetUsersSelect;
